import { cva } from "class-variance-authority";

// SCSS-based button variants using WeLoop design system classes
export const buttonVariants = cva(
  "wl-btn", // Base WeLoop button class
  {
    variants: {
      variant: {
        default: "",
        primary: "wl-btn-primary",
        outline: "wl-btn-primary-outline",
        text: "wl-btn-primary-text",
        danger: "wl-btn-danger",
        "danger-outline": "wl-btn-danger-outline",
        "danger-text": "wl-btn-danger-text",
        link: "wl-btn-link",
        white: "wl-btn-white",
        ghost: "wl-btn-ghost", // Added missing ghost variant
        "primary-icon": "wl-btn-primary wl-btn-icon",
        "outline-icon": "wl-btn-primary-outline wl-btn-icon",
        "text-icon": "wl-btn-primary-text wl-btn-icon",
        "danger-icon": "wl-btn-danger wl-btn-icon",
        "danger-outline-icon": "wl-btn-danger-outline wl-btn-icon",
        "danger-text-icon": "wl-btn-danger-text wl-btn-icon",
        "white-icon": "wl-btn-white wl-btn-icon",
      },
      size: {
        default: "", // Default size is handled by wl-btn
        sm: "wl-btn-sm",
        lg: "wl-btn-lg",
        icon: "wl-btn-icon", // Added missing icon size
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);
